export const style = {
  container: {
    margin: 'auto',
    direction: 'column',
    alignItems: 'center',
    // using rem for consistency with other components
    paddingX: { base: '2rem', sm: '1rem' },
    maxWidth: { base: '100%', sm: '28rem' },
    width: {
      md: '28rem',
    },
    gridRowGap: '10',
  },
  heading: {
    mt: '1rem',
    fontSize: '2xl',
    color: 'gray.700',
    textAlign: 'center',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gridRowGap: '2',
    paddingBottom: '8',
  },
  description: {
    paddingY: '3',
  },
  secureDataContainer: {
    columnGap: '3',
    paddingY: '3',
  },
  secureDataBox: {
    paddingY: '1',
    boxSize: '10',
  },
  secureDataImage: {
    minWidth: '100%',
  },
  whatIsClabe: {
    alignSelf: 'flex-start',
  },
  submit: {
    paddingX: '3rem',
    alignSelf: 'flex-end',
  },
};
